import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3816b91c&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=3816b91c&prod&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=3816b91c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3816b91c",
  null
  
)

export default component.exports